(function() {
  
    window.CanvasSlideshow = function(options) {

        //  SCOPE  
        var self = this;
      
        //  OPTIONS
        options                     = options || {};
        options.app                 = options.hasOwnProperty('app') ? options.app : '';
        options.container           = options.hasOwnProperty('container') ? options.container : document.body;
        options.stageWidth          = options.hasOwnProperty('stageWidth') ? options.stageWidth : options.container.clientWidth;
        options.stageHeight         = options.hasOwnProperty('stageHeight') ? options.stageHeight : options.container.clientHeight;
        options.pixiSprites         = options.hasOwnProperty('sprites') ? options.sprites : [];
        options.projects            = options.hasOwnProperty('projects') ? options.projects : [];
        options.projectsCounter     = options.hasOwnProperty('projectsCounter') ? options.projectsCounter : [];
        options.displaceScale       = [5000, 10000]
        options.displacementImage   = options.hasOwnProperty('displacementImage') ? options.displacementImage : '';
        options.displaceScaleTo     = [20, 20];
        options.navElement          = options.hasOwnProperty('navElement')  ? options.navElement : document.querySelectorAll( '.scene-nav' );

        //  PIXI VARIABLES
        var displacementSprite  = new PIXI.Sprite.fromImage(options.displacementImage);
        var displacementFilter  = new PIXI.filters.DisplacementFilter(displacementSprite);
        
        // on crée un canvas par projet
        options.projects.forEach(function(element){
            element.renderer = new PIXI.autoDetectRenderer(options.stageWidth, options.stageHeight, {transparent: true});
            element.stage = new PIXI.Container();
            element.window = element.querySelectorAll('.item-title')[0];
        });
        
        //  si un projet est chargé, on donne son ID à la var currentIndex, sinon on le met à 0
        if (options.app.projectLoaded === true) {
            options.projects.forEach(function(element) {
                if (element.getAttribute('data-name') === options.app.$route.params.projectId) {
                    self.currentIndex = parseInt(element.getAttribute('data-id'));
                    options.projects[self.currentIndex].classList.add('is-active');
                }
            });
        } else {            
            this.currentIndex = 0;
        }
        // on donne une valeur par défaut au compteur
        options.projectsCounter.setAttribute('data-counter', self.currentIndex+1);
        

        /// ---------------------------
        //  INITIALISE PIXI
        /// ---------------------------      
        this.initPixi = function() {
            displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
            displacementSprite.scale.x = 2;
            displacementSprite.scale.y = 2;
                        
            // PIXI tries to fit the filter bounding box to the renderer so we optionally bypass
            displacementFilter.autoFit = false;            
            
            // Add canvases to the HTML
            options.projects.forEach(function(element){
                if (!options.app.projectLoaded) {                    
                    element.renderer.view.classList.add('c-hover');
                }
                element.querySelectorAll('.item-link')[0].appendChild(element.renderer.view);
                element.stage.addChild(displacementSprite);
                element.stage.filters = [displacementFilter];
                element.renderer.render(element.stage);
            });
            
            this.loadPixiSprites(options.pixiSprites);
        };


        /// ---------------------------
        //  LOAD SLIDES TO CANVAS
        /// ---------------------------          
        this.loadPixiSprites = function(sprites) {        

            var i = 0;
            options.projects.forEach(function(element) {
                var texture   = new PIXI.Texture.fromImage(sprites[i]);
                var image     = new PIXI.Sprite(texture);
                image.width   = options.stageWidth;
                image.height   = options.stageHeight;
                               
                if (i !== self.currentIndex) {                    
                    TweenMax.set(element.stage, {alpha: 0});
                    TweenMax.set(element.window.querySelectorAll("span span"), {autoAlpha: 0});
                } else {
                    TweenMax.set(element.stage, {alpha: 1});
                    TweenMax.set(element.window.querySelectorAll("span span"), {autoAlpha: 1});
                }
                
                element.stage.addChild(image);                
                
                // si un projet est chargé, on stop l'effet d'eau
                if (options.app.projectLoaded === true && i === options.projects.length - 1) {
                    // condition pour éviter bug au cas de retour arrière
                    if (texture.baseTexture.hasLoaded && options.app.$route.name === 'project_component') {
                        self.stopTicker();
                    } else {                        
                        texture.baseTexture.on('loaded', function() {
                            if (options.app.$route.name === 'project_component') {
                                self.stopTicker();
                            }
                        })
                    }
                }
                
                i++;                
            });            
            
            
            
            // déplacé ici pour éviter un bug quand on scroll trop tot au chargement de la page
            if (options.app.projectLoaded === false) {
                this.listenScroll();
            }
            
            // resize window
            window.addEventListener('resize', this.resizeCanvas);
            
            // pour eviter bug quand on revient de mobile à destop en liste
            if (options.app.isList) {
                this.showAllCanvases()
            }
        };      


        /// ---------------------------
        //  DEFAULT RENDER/ANIMATION
        /// ---------------------------        
        var ticker = new PIXI.ticker.Ticker();        
        ticker.autoStart = true;
        
        // effet d'eau continuel
        ticker.add(function(delta) {
            displacementSprite.x += 4 * delta/2;
            displacementSprite.y += 3/2;
                      
//            if (options.app.isList) {                
                options.projects.forEach(function(element) {///////////////////////////////
                    element.renderer.render(element.stage);
                });
//            } else {
//                options.projects[self.currentIndex].renderer.render(options.projects[self.currentIndex].stage)
//                options.projects[3].renderer.render(options.projects[3].stage)
//            }
        });
      

        /// ---------------------------
        //  TRANSITION BETWEEN SLIDES
        /// ---------------------------    
        var isPlaying = false;
        
        this.moveSlider = function(newIndex, callback) {
            isPlaying = true;
            
            options.projectsCounter.setAttribute('data-counter', newIndex+1);

            // on redonne le z-index de base au projet précédent
            options.projects[self.currentIndex].classList.remove('is-active');
            // on donne un z-index fort au projet actuel
            options.projects[newIndex].classList.add('is-active');
            
            var baseTimeline = new TimelineMax({                
                onComplete: function() {
                    
                    self.currentIndex = newIndex;                    
                    
                    isPlaying = false;
                    
                    if (typeof(callback) !== 'undefined') {
                        callback();
                    }
                }
            });

            baseTimeline.clear();
            
            // on annule l'animation s'il y en a déjà une active ou si un projet est chargé
            if (baseTimeline.isActive() || options.app.projectLoaded) {
                return;
            }
            
            baseTimeline            
            .to(displacementFilter.scale, 0.8, {x: options.displaceScale[0], y: options.displaceScale[1], ease: Power2.easeIn})
            .to(options.projects[self.currentIndex].stage, 0.5, {alpha: 0, ease: Power2.easeOut}, 0.4)
            .to(options.projects[newIndex].window.querySelectorAll("span span"), 0.5, {x: -20, y: -20, autoAlpha: 0}, 0)
            .to(options.projects[newIndex].stage, 0.5, {alpha: 1, ease: Power2.easeIn}, 1)
            .to(displacementFilter.scale, 0.7, {x: options.displaceScaleTo[0], y: options.displaceScaleTo[1], ease: Power1.easeOut}, 0.9)
            
            TweenMax.staggerTo(options.projects[self.currentIndex].window.querySelectorAll("span span"), 0, {x: 15, y: 15, autoAlpha: 0}, 0.03)
            TweenMax.staggerTo(options.projects[newIndex].window.querySelectorAll("span span"), 0, {x: 0, y: 0, autoAlpha: 1, delay: 1.1}, 0.03)
            
        };
        
        
        /// ---------------------------
        //  HIDE/SHOW ONE CANVAS
        /// ---------------------------
        this.hideOneCanvas = function(index) {
            
            isPlaying = true;
            
            // on redonne le z-index de base au projet actuel
            options.projects[self.currentIndex].classList.remove('is-active');
            
            var baseTimeline = new TimelineMax({
                onComplete: function() {
                    options.app.isList = true;
                    options.app.isFull = false;
                }
            });
            baseTimeline.clear();

            if (baseTimeline.isActive()) {
                return;
            }        

            baseTimeline
            .to(displacementFilter.scale, 0.8, {x: options.displaceScale[0], y: options.displaceScale[1], ease: Power2.easeIn})
            .to(options.projects[index].stage, 0.5, {alpha: 0, ease: Power2.easeOut}, 0.4)
            
            TweenMax.staggerTo(options.projects[index].window.querySelectorAll("span span"), 0, {x: 15, y: 15, autoAlpha: 0}, 0.03)
        }
                
        this.showOneCanvas = function(index, loadProject) {
            
            if (typeof(index) === 'undefined') {
                index = 0;
            }
            
            // z-index
            options.projects[index].classList.add('is-active');

            var baseTimeline = new TimelineMax({
                onComplete: function() {
                    
                    if (loadProject === true) {
                        self.stopTicker();
                    }
                    
                    options.app.allowAnimation();
                    
                    isPlaying = false;
                 }
            });
            baseTimeline.clear();

            if (baseTimeline.isActive()) {
              return;
            }        

            baseTimeline
            .to(options.projects[index].stage, 0.5, {alpha: 1, ease: Power2.easeIn}, 1)
            .to(options.projects[index].window, 0.5, {alpha: 1, ease: Power2.easeIn}, 1.2)
            .to(displacementFilter.scale, 0.7, {x: options.displaceScaleTo[0], y: options.displaceScaleTo[1], ease: Power1.easeOut}, 0.9)
            
            TweenMax.staggerTo(options.projects[index].window.querySelectorAll("span span"), 0, {x: -20, y: -20, autoAlpha: 0, delay: 1}, 0)
            TweenMax.staggerTo(options.projects[index].window.querySelectorAll("span span"), 0, {x: 0, y: 0, autoAlpha: 1, delay: 1.1}, 0.03)
        };
        
        
        /// ---------------------------
        //  HIDE/SHOW ALL CANVASES
        /// ---------------------------
        this.hideAllCanvases = function() {
            
            isPlaying = true;

            var baseTimeline = new TimelineMax({
                onComplete: function() {
                    options.app.isList = false;
                    options.app.isFull = true;
                }
            });
            baseTimeline.clear();

            if (baseTimeline.isActive()) {
              return;
            }        

            baseTimeline
            .to(displacementFilter.scale, 0.8, {x: options.displaceScale[0], y: options.displaceScale[1], ease: Power2.easeIn})
            
            options.projects.forEach(function(element) {
                baseTimeline.to(element.stage, 0.5, {alpha: 0, ease: Power2.easeOut}, 0.4)

                TweenMax.staggerTo(element.window.querySelectorAll("span span"), 0, {x: 15, y: 15, autoAlpha: 0}, 0.03)
            });
            
        }
        
        
        this.showAllCanvases = function() {

            var baseTimeline = new TimelineMax({
                onComplete: function() {
                    
                    options.app.allowAnimation();
                    
                    isPlaying = false;
                }
            });
            baseTimeline.clear();

            if (baseTimeline.isActive()) {
              return;
            }        

            baseTimeline
            .to(displacementFilter.scale, 0.7, {x: options.displaceScaleTo[0], y: options.displaceScaleTo[1], ease: Power1.easeOut}, 0.9);
            
            options.projects.forEach(function(element){
                baseTimeline
                    .to(element.stage, 0.5, {alpha: 1, ease: Power2.easeIn }, 1)
                
                TweenMax.staggerTo(element.window.querySelectorAll("span span"), 0, {x: -20, y: -20, autoAlpha: 0, delay: 1}, 0)
                TweenMax.staggerTo(element.window.querySelectorAll("span span"), 0, {x: 0, y: 0, autoAlpha: 1, delay: 1.1}, 0.03)
                
            });
        }
        

        /// ---------------------------
        //  CLICK HANDLERS
        /// ---------------------------         
        var nav = options.navElement;
        var navBtns = nav.childNodes;

        for (var i = 0; i < navBtns.length; i++) {

            var navItem = navBtns[i];

            navItem.onclick = function(event) {

                // Make sure the previous transition has ended
                if (isPlaying === true || options.app.projectLoaded === true || options.app.isList === true || options.app.isAnimating === true) {
                    return false;
                }

                if (this.classList.contains('slider-next')) {
                    self.nextSlide();
                } else if (this.classList.contains('slider-prev')) {
                    self.previousSlide();
                }

                return false;
            }
        }
    
        
        /// ---------------------------
        //  SCROLL HANDLERS
        /// --------------------------- 
        this.scrollEvent = function(event) {
            if (isPlaying || options.app.projectLoaded || options.app.isList || options.app.$parent.$refs.appbase.$refs.loader.isLoading) {
                return false;
            }
            event.deltaY < 0 ? self.previousSlide() : self.nextSlide();
        }
        this.scrollEvent = this.scrollEvent.bind(this)
        
        this.listenScroll = function() {
            document.addEventListener('wheel', this.scrollEvent);
        }
        this.unListenScroll = function() {
            document.removeEventListener('wheel', this.scrollEvent);
        }       
                
        
        /// ---------------------------
        //  SLIDE FUNCTIONS
        /// ---------------------------  
        this.nextSlide = function(callback) {
            if (self.currentIndex >= 0 && self.currentIndex < options.projects.length - 1) {
                self.moveSlider(self.currentIndex + 1, callback);
            } else {
                self.moveSlider(0, callback);
            }
            
            options.app.$parent.isProjectsScrolled = true;
        }
        
        this.previousSlide = function(callback) {
            if (self.currentIndex > 0 && self.currentIndex < options.projects.length) {
                self.moveSlider(self.currentIndex - 1, callback);
            } else {
                self.moveSlider(options.projects.length - 1, callback);
            }
            
            options.app.$parent.isProjectsScrolled = true;
        }
        
        
        /// ---------------------------
        //  FILTERS
        /// ---------------------------    
        this.filterList = function() {
            this.hideOneCanvas(self.currentIndex);
            this.showAllCanvases();
        };
        this.filterFull = function() {
            this.hideAllCanvases();
            this.showOneCanvas(self.currentIndex);
        };
      
        /// ---------------------------
        //  STOP 
        /// ---------------------------
        
        // Stop canvas
        this.stopCanvas = function(project) {
            this.currentIndex = parseInt(project.$el.getAttribute('data-id'));
            this.unListenScroll();

            if (options.app.isList === true) {
                this.hideAllCanvases();
                this.showOneCanvas(this.currentIndex, true);
            } else {
                this.stopTicker();
            }
        }
        
        // Stop Ticker
        this.stopTicker = function() {
            var self = this;
            TweenMax.to(displacementFilter.scale, 1, {x: 1, y: 1, ease: Power2.easeIn, onComplete: function() {
                ticker.stop();
                self.removeHoverClasses();
            }});
        }
        
        // Start Ticker
        this.startTicker = function() {
            this.addHoverClasses();
            
            ticker.start();
            TweenMax.to(displacementFilter.scale, 1.2, {x: options.displaceScaleTo[0], y: options.displaceScaleTo[1], ease: Power2.easeInOut});
        }
        
        this.destroy = function() {
            setTimeout(function() {                
                options.projects.forEach(function(element) {
                    element.renderer.destroy(true);
                });
            }, 800);
            self.unListenScroll();
            ticker.destroy();
        }
        
        // Hover classes
        this.addHoverClasses = function() {
            options.projects.forEach(function(element){
                element.renderer.view.classList.add('c-hover');
            });
        }
        this.removeHoverClasses = function() {
            options.projects.forEach(function(element){
                element.renderer.view.classList.remove('c-hover');
            });
        }
        
      
        /// ---------------------------
        //  INIT FUNCTIONS
        /// ---------------------------    

        this.init = function() {        
            this.initPixi();
            
            // déplacé à la fin de initPixi pour éviter le bug ou le canvas n'apparait pas quand on load directement la page d'un projet
//            this.loadPixiSprites(options.pixiSprites)            
        };
        
        /// ---------------------------
        //  MISC
        /// ---------------------------
        this.checkIfPlaying = function() {
            if (isPlaying === true) {
                return true;
            } else {
                return false;
            }
        }
      
        /// ---------------------------
        //  START 
        /// ---------------------------           
        this.init();         
        
    };

  })(); 


// WEBPACK FOOTER //
// ./src/assets/js/slider.js